// Shared path guards. AdminClient, HttpConsoleDataSource, and the
// same-origin Pages proxies must refuse the same population — a second copy
// that drifted would reopen the open-relay those proxies exist to close.

export const ADMIN_API_PATH = /^\/v1\/admin(\/|$)/;

/** Exact Link routes the console may reach same-origin. Not a prefix. */
export const LINK_API_PATHS = new Set(["/link/session", "/link/exchange"]);

/** Pathname only — strip the query before matching. */
export function isAdminApiPath(path: string): boolean {
  const pathname = path.split("?")[0] ?? path;
  return ADMIN_API_PATH.test(pathname);
}

/**
 * Exact `/link/session` and `/link/exchange` only. Prefix matching here
 * would turn the Link proxy into a relay (`/link/session/../v1/admin/…`).
 */
export function isLinkApiPath(path: string): boolean {
  const pathname = path.split("?")[0] ?? path;
  return LINK_API_PATHS.has(pathname);
}
